var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClockGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 9,
    viewBox: "0 0 6 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1249_2913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.71486 0.692308H1.28627C1.11051 0.692308 0.964844 0.535431 0.964844 0.346154C0.964844 0.156877 1.11051 0 1.28627 0H4.71486C4.89062 0 5.03629 0.156877 5.03629 0.346154C5.03629 0.535431 4.89062 0.692308 4.71486 0.692308Z",
    fill: "#27A376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.71486 8.99992H1.28627C1.11051 8.99992 0.964844 8.84305 0.964844 8.65377C0.964844 8.46449 1.11051 8.30762 1.28627 8.30762H4.71486C4.89062 8.30762 5.03629 8.46449 5.03629 8.65377C5.03629 8.84305 4.89062 8.99992 4.71486 8.99992Z",
    fill: "#27A376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.49997 1.26918H1.50003C0.501425 1.26918 0 1.80918 0 2.88447V6.1152C0 7.19063 0.501425 7.73063 1.50003 7.73063H4.49997C5.49857 7.73063 6 7.19063 6 6.1152V2.88447C6 1.80904 5.49857 1.26904 4.49997 1.26904V1.26918ZM4.07144 5.07687H2.78574C2.60998 5.07687 2.46431 4.92 2.46431 4.73072V3.3461C2.46431 3.15683 2.60998 2.99995 2.78574 2.99995C2.96149 2.99995 3.10716 3.15683 3.10716 3.3461V4.38457H4.07144C4.2472 4.38457 4.39287 4.54144 4.39287 4.73072C4.39287 4.92 4.2472 5.07687 4.07144 5.07687Z",
    fill: "#27A376"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1249_2913"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 9,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockGreen);
export default __webpack_public_path__ + "static/media/clock-green.5df8c52ce0e850304178f9d2f1c396dc.svg";
export { ForwardRef as ReactComponent };